<template>
    <f7-popup
		ref="new-payment-popup"
		class="new-payment-popup popup-router-open-in"
		@popup:opened="opened"
		@popup:close="eventClosePopup"
		:close-by-backdrop-click="!isLightTarget"
	>
        <span class="tint"></span>
        <f7-view url="/payment/create/config">
        </f7-view>
    </f7-popup>
</template>

<script setup lang="ts">
import { computed } from "vue";
import PopupPaymentCreateController from "@components/popup/popup-payment-create/PopupPaymentCreateController";
import NewPaymentController from "@/views/payment-create-config/NewPaymentController";

const opened = () => {
	const popupHTML = document.querySelector('.new-payment-popup');
	(popupHTML as HTMLDivElement).classList.add('transition');

	const func = PopupPaymentCreateController.of().popupOpenedFunction;
	if (func) func();
}

const eventClosePopup = (e: any) => {
	close();
}

const close = async () => {
	const popupHTML = document.querySelector('.new-payment-popup');
	(popupHTML as HTMLDivElement).classList.remove('transition');
	NewPaymentController.getInstance().destructor();
}

const isLightTarget = computed(() => import.meta.env.VITE_APP_TYPE === 'light');
</script>

<style lang="scss">
.new-payment-popup {
    //height: calc(var(--f7-safe-area-bottom) + 322px) !important;
    bottom: 0px !important;
    top: unset !important;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;

    .tint {
        width: 36px;
        height: 4px;
        position: absolute;
        top: 6px;
        z-index: 9999;
        background: #818E95;
        border-radius: 4px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%)
    }

    &.transition {
        transition: 0.4s ease height;
    }
}
.with-modal-popup {
    #app {
        .new-payment-popup {
            &.height-100 {
                height: calc(100% - var(--f7-safe-area-top)) !important;
            }
        }
    }
}

//.sheet-modal-new-payment {
//    border-top-left-radius: 16px;
//    border-top-right-radius: 16px;
//
//    .sheet-modal-inner {
//        border-top-left-radius: inherit;
//        border-top-right-radius: inherit;
//    }
//
//    .title {
//        font-weight: 700;
//        font-size: 22px;
//        line-height: 120%;
//        letter-spacing: 0.337647px;
//        color: #000000;
//    }
//}
</style>
